module.exports = __webpack_public_path__ + "static/reincloud-7f501adcde964b57383315a975a4124b.png";